import { Text } from '@src/shared/ui';
import React from 'react';

type DescriptionContentProps = {
  children: React.ReactNode;
  className?: string;
};

export const DescriptionContent: React.FC<DescriptionContentProps> = ({
  children,
  className,
}) => {
  return (
    <Text
      fontSize='md'
      color='neutral70'
      fontWeight='regular'
      lineHeight='base'
      className={className}
    >
      {children}
    </Text>
  );
};
